module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-HeavyIt.05fdd987.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/AvenirNextLTPro-HeavyIt.eot
// module id = 80
// module chunks = 0